import { fb } from '../firebase/config';
import 'firebase/storage';

export const FileUploadService =  {

  upload: async (file, account) => {
    const fileRef = fb.storage().ref(account).child(file.name);
    const result = await fileRef.put(file);
    return await result.ref.getDownloadURL();
  }
}